<app-student-nav></app-student-nav>

<section class="search-results">
  @if (query) {
    <h1 class="search-results-title">Search results for "{{ query }}"</h1>
  } @else {
    <h1 class="search-results-title">Search</h1>
    <p class="search-results-empty" data-testid="search-results-empty">
      Type a query in the search bar above to get started.
    </p>
  }

  @if (query) {
    <div class="search-results-grid">
      @for (category of categories; track category.label) {
        <mat-card
          class="search-results-card"
          [class.disabled]="!category.route"
          (click)="goToCategory(category)"
          [attr.data-testid]="'search-category-' + category.label.toLowerCase()"
        >
          <mat-icon aria-hidden="true">{{ category.icon }}</mat-icon>
          <div class="search-results-card-label">{{ category.label }}</div>
          @if (category.route) {
            <div class="search-results-card-desc">See matches in {{ category.label }}</div>
          } @else {
            <div class="search-results-card-desc">Search coming soon</div>
          }
        </mat-card>
      }
    </div>
  }
</section>
